import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { useDialog } from '@repo/ui';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import { getIndividualRefundData } from '@/components/tax-refund/common/data/individual-refund-data';
import HometaxSessionError from '@/components/tax-refund/common/view/ErrorView/HometaxSessionError';
import { COMMON_PATHS, INDIVIDUAL_PATHS } from '@/lib/constants/paths';
import { checkHometaxAvailableTime } from '@/lib/utils/hometax-time';

const ErrorPage = () => {
  const router = useRouter();
  const { showDialog } = useDialog();
  const refundData = getIndividualRefundData();
  const { sendClickEvent } = useUserEventLogger();

  const checkHometaxHour = () => {
    /* 오전 6시 ~ 밤 0시 아닌 경우 홈택스 조회 불가 */
    if (!checkHometaxAvailableTime()) {
      showDialog({
        title: '아침 6시 이후에 조회해주세요',
        description: '매일 밤 0시부터 아침 6시까지 홈택스 점검으로 환급액 조회가 어려워요.'
      });
      return false;
    }

    return true;
  };

  const handleClickExit = () => {
    sendClickEvent('indis-lookup_error-session_close');

    router.push({
      pathname: `${COMMON_PATHS.환급조회목록}`,
      query: router.query
    });
  };

  const handleRetry = () => {
    sendClickEvent('indis-lookup_error-session_retry');

    if (checkHometaxHour()) {
      switch (refundData?.authType) {
        case 'simple-auth':
          router.push({
            pathname: COMMON_PATHS.간편인증_정보입력,
            query: { from: 'lookup' }
          });
          break;

        case 'joint-certificate':
          router.push({
            pathname: `${INDIVIDUAL_PATHS.개인공동인증서선택}`,
            query: router.query
          });
          break;

        default:
          router.push({
            pathname: `${COMMON_PATHS.환급조회목록}`,
            query: router.query
          });
          break;
      }
      // TODO 개인 간편인증 사용자 -> 간편인증 입력 페이지로 데이터 채워진 채로 이동
      // TODO 개인/법인 공동인증 사용자 -> 프로그램 설치 여부 판단 1로 이동
      // TODO 법인 홈택스 사용자 -> 홈택스 아이디 입력 단계로  데이터 채워진 채로 이동
    }
  };

  return (
    <AuthGuard>
      <PageViewEventLogger pageName="indis-lookup_error-session" />
      <Layout
        rightTextButton={{
          label: '나가기',
          state: 'gray',
          onClick: handleClickExit
        }}
      >
        <HometaxSessionError onPrimaryButtonClick={handleRetry} />
      </Layout>
    </AuthGuard>
  );
};

export default ErrorPage;
